import { css } from '@emotion/core'
import styled from '@emotion/styled'

import { iconSizeToNumber } from '../../../Icon'
import { sizeToProps } from '../../constants/sizeToProps'
import { InputSize } from '../../types/size'
import { getIconSize } from '../../utils/getIconSize'

interface InputPrefixWrapperProps {
  disabled: boolean
  inputSize: InputSize
}

const getCompensedPaddingStyles = (inputSize: InputSize) => {
  const { spacingX } = sizeToProps[inputSize]

  return css`
    margin: -${spacingX};
    padding: 0 ${spacingX};
  `
}

export const InputPrefixSuffixWrapper = styled.div<InputPrefixWrapperProps>`
  display: flex;
  opacity: ${({ disabled }) => (disabled ? 0.5 : 1)};
  align-items: center;
  flex-shrink: 0;
  pointer-events: ${({ disabled }) => (disabled ? 'none' : 'all')};
  ${({ inputSize }) => getCompensedPaddingStyles(inputSize)}

  // Enforce consistent icon sizing when an <Icon> is used in prefix/suffix (outside DS)
  svg {
    width: ${({ inputSize }) => iconSizeToNumber[getIconSize(inputSize)]}px;
    height: ${({ inputSize }) => iconSizeToNumber[getIconSize(inputSize)]}px;
  }
`
